import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import ImageSvg from "../ui/image-svg";
import { ScrollToTop } from "../ui/ScrollToTop";
import Footer from "./Footer";
import { HeaderClean } from "./header/HeaderClean";

export default function LayoutEcommerce() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const isQuotePage = location.pathname.includes("/cotacao/");

  return (
    <div className="min-h-screen flex flex-col bg-n-bg-1">
      <HeaderClean />
      {isQuotePage && (
        <div className="sticky top-[56px] md:top-[72px] z-40 bg-n-beige ">
          <div className="flex items-center justify-center  py-2 gap-3">
            <div className="w-5 h-5 rounded-full bg-white p-1 flex items-center justify-center flex-shrink-0">
              <ImageSvg
                src="reclameaqui.svg"
                alt="Reclame Aqui"
                className="object-contain w-full h-full"
              />
            </div>
            <span className="text-sm font-medium text-n-green">
              Somos Nota Máxima no Reclame Aqui
            </span>
          </div>
        </div>
      )}
      <main className="flex-1 mt-[50px] md:mt-[72px]">
        <Outlet />
      </main>
      <ScrollToTop />
      <Footer variant="simple" />
    </div>
  );
}
